import BaseModel from '../../../plugins/servicelayer/serviceTypes/baseModel';

export interface DynamicFormFieldDTO {
  values: string[],
  id: string
}

export default class DynamicFormFieldViewModel extends BaseModel<DynamicFormFieldDTO> {
  protected transformToDTO = () => {};

  get values() { return this.dto.values; }
  set values(value) { this.dto.values = value; }

  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
}
